
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import store from '../store';
import { getUserToken, authMethod } from '@/utils/auth';
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 150000 // 请求超时时间
});

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code !== 1) {

      // -37:未登录; 50012:其他客户端登录了;  -31:access_token 为验证;
      if (res.code === -37 || res.code === -31) {
				MessageBox.alert('您未登录,不能进行此操作', '确定', {
					confirmButtonText: '确定',
					callback: action => {
						store.dispatch('FedLogOut').then(() => {
							location.reload();// 为了重新实例化vue-router对象 避免bug
						});
					}
				});
      }else{
				Message({
					message: res.msg,
					type: 'error',
					duration: 5 * 1000
				});
      }
      return Promise.reject(res);
    } else {
      return response.data;
    }
  },
  error => {
    console.log('err' + error);// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error.message);
  }
);

function getHeader(extDataStr){
  const headers = {};
  const data = authMethod.genAllParam(
    store.getters.appId,
    store.getters.appKey,
    getUserToken(),
    extDataStr);
  for (const k in data) {
    if (k !== 'params') {
      headers[k] = data[k];
    }
  }
  return headers;
}
export function header(extDataStr){
  return getHeader(extDataStr);
}
export function get(url, config){
  config = config || {};
  const headers = getHeader();
  config.headers = Object.assign({}, config.headers, headers);
  return service.get(url, config);
}

export function post(url, data, config){
  config = config || {};
  const paramString = JSON.stringify(data);
  const headers = getHeader(paramString);
  config.headers = Object.assign(
    {},
    config.headers,
    headers,
    { 'Content-Type': 'application/json' }
  );
  return service.post(url, paramString, config);
}

export default function(config){
  config = config || {};
  if (!config.url) {
    return false;
  }
  let paramString;
  let postHeader;
  if (config.method === 'post') { // post
    paramString = JSON.stringify(config.data);
    config.data = paramString;
    postHeader = { 'Content-Type': 'application/json' };
  }
  const headers = getHeader(paramString);
  config.headers = Object.assign({}, config.headers, headers, postHeader);

  return service(config);
}



// WEBPACK FOOTER //
// ./src/utils/request.js